import React, { useContext, useEffect, useState } from "react";
import { SetStockTransferList, GetStockTransferList, GetStockTransferEdit, ResetTransferEdit } from "../../store/stockTransferAtom";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import StockWareHouseSelect from "./StockWareHouseSelect";
import { useForm } from 'react-hook-form';
import { stockTransferService } from "../../services/stockTransferService";
import LogicContext from "../../Context/LogicContext";
import moment from "moment";
import StockProductSelect from "./StockProductSelect";
import { useNavigate } from "react-router-dom";

export default function StockTransferAddNewPage() {
  const setStockTransferData = SetStockTransferList();
  const resetEdit = ResetTransferEdit();
  const getStockTransferData = GetStockTransferList();
  const myPromiseModal = createModal(GeneralModal);
  const [form, setForm] = useState({
    refNo: "",
    date: new Date().toISOString().substring(0, 10),
    fromWarehouse: "",
    toWarehouse: "",
    remark: "",
  });

  const { register, handleSubmit, setValue, getValues, formState: { errors } } = useForm();
  const [selectedProductId, setSelectedProductId] = useState("");
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [finalList, setFinalList] = useState([]);
  const { showToast, httpResponseManager } = useContext(LogicContext);
    const editStockStransfer  = GetStockTransferEdit();
  

  const selectedProduct = items.find((p) => p.item_id === selectedProductId);


  useEffect(()=> {
    if(editStockStransfer?.transfer_main?.[0]?.ref_no){
      setValue('ref_no',editStockStransfer?.transfer_main?.[0]?.ref_no );
      // Format it to YYYY-MM-DD so the HTML input accepts it
      const formattedDate = moment(editStockStransfer?.transfer_main?.[0]?.transfer_date).format('YYYY-MM-DD');
      setValue('Transfer_date', formattedDate);
      setValue('warehouse_from_id',editStockStransfer?.transfer_main?.[0]?.warehouse_from_id );
      setValue('warehouse_to_id',editStockStransfer?.transfer_main?.[0]?.warehouse_to_id );
      setValue('remark',editStockStransfer?.transfer_main?.[0]?.remark );


      if(editStockStransfer?.transfer_details?.length){
        const newList = editStockStransfer.transfer_details.map((item)=> {
          return {...item, quantity: item.item_quantity}
        });
        setFinalList(newList);
      }

    }

    if(editStockStransfer?.transfer_main?.[0]?.warehouse_from_id){
      onWarehouseFromSelect({warehouse_id: editStockStransfer?.transfer_main?.[0]?.warehouse_from_id});
    }

      return ()=> {
        resetEdit()
      }
  },[editStockStransfer, setValue]);

  const addItem = () => {
    if (!selectedProduct || quantity <= 0) return;

    setFinalList((prev) => {
      const existing = prev.find((i) => i.item_id === selectedProduct.item_id);
      if (existing) {
        return prev.map((i) =>
          i.item_id === selectedProduct.item_id
            ? { ...i, quantity: i.quantity + Number(quantity) }
            : i
        );
      }
      return [
        ...prev,
        {
          ...selectedProduct,
          quantity: Number(quantity),
        },
      ];
    });

    setQuantity(1);
  };

  const updateQuantity = (id, value) => {
    setFinalList((prev) =>
      prev.map((i) =>
        i.item_id === id ? { ...i, quantity: Number(value) } : i
      )
    );
  };

  const removeItem = (id) => {
    setFinalList((prev) => prev.filter((i) => i.item_id !== id));
  };

  const handleSave = async () => {
    let option = '1';
    // editStockStransfer?.transfer_main?.[0]?.ref_no
    if(editStockStransfer?.transfer_main?.[0]?.ref_no){
      option = '2';
    }

    if (finalList.length === 0) {
      return showToast('At least one item should be on the transfer list', 'error');
    }

    const warehouseTo = getValues('warehouse_to_id');
    if (!warehouseTo) {
      return showToast('Please select a WareHouse you want to transfer to', 'error');
    }

    const confirm = await myPromiseModal({
      title: ` ${editStockStransfer?.transfer_main?.[0]?.ref_no ? "Update Stock Transfer": "Confirm Stock Transfer"} `,
      body: `You are about to transfer ${finalList.length} item(s) to a new Warehouse`,
      showInput: false,
    });
    if (!confirm?.decision) return;

    const formData = getValues();
    const xmlItems = finalList
      .map(item => `<a><item_id>${item.item_id}</item_id><item_quantity>${item.quantity}</item_quantity> </a>`)
      .join('');

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      payload.set(key, value || '');
    });
    payload.set('option', option);
    payload.set('xml_string_item', `<root>${xmlItems}</root>`);

    try {
      const res = await stockTransferService.submitStockTransfer(payload);
      const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        showToast(response.message_text || 'Stock Transfer successful!', 'success');
        sessionStorage.setItem('reloadPage', 'true');
        navigate(-1);
      } else {
        showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (err) {
      // showToast('Error submitting form', 'error');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const onWarehouseFromSelect = async (sel) => {
    setValue('warehouse_from_id', sel.warehouse_id);
     setItems([]);
    const res = await stockTransferService.stockWareHouseDetails(sel.warehouse_id);
    console.log('incoming ', res.data?.item_info);
    if (res.data?.item_info?.length) {
      console.log('item is SET');
      setItems(res.data?.item_info);
      if(!editStockStransfer?.transfer_main?.[0]?.ref_no){
        setFinalList([]); // If not in edit mode, do not clear list
      }
    } else {
      showToast('The selected Warehouse do not have items');
    }
  }

  const onWarehouseToSelect = async (sel) => {
    setValue('warehouse_to_id', sel.warehouse_id);
  }

  const onItemSelected = async (item) => {
    setSelectedProductId(item?.item_id);
  }


    const baseDateData = editStockStransfer?.transfer_main?.[0]?.transfer_date;
    const defaultDate = baseDateData 
    ? moment(baseDateData).format('YYYY-MM-DD') // Correct: Let moment auto-detect ISO
    : moment().format('YYYY-MM-DD');

  


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">Stock Transfer</h1>
          <p className="text-slate-600">Transfer inventory between warehouses</p>
        </div>

        {/* Main Form Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-6">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-2 py-2">
            <h2 className="text-lg font-semibold text-white flex items-center gap-2">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Transfer Information
            </h2>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Reference Number
                </label>
                <input
                value={editStockStransfer?.transfer_main?.[0]?.transfer_number}
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm bg-slate-50 text-slate-500"
                  placeholder="Auto Generated"
                  readOnly={true}
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Transfer Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  defaultValue={defaultDate}
                  {...register('Transfer_date', { required: 'Transfer date is required' })}
                />
                {errors.Transfer_date && (
                  <p className="text-red-500 text-xs mt-1">{errors.Transfer_date.message}</p>
                )}
              </div>

              <div className="md:col-span-2 lg:col-span-1 lg:row-span-2">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Remarks (Optional)
                </label>
                <textarea
                  rows="4"
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none"
                  placeholder="Add any additional notes here..."
                  {...register('remark')}
                />
              </div>

              <div className="relative z-0">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  From Warehouse <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <StockWareHouseSelect
                    list={getStockTransferData?.warehouse || []}
                    defaultValue={editStockStransfer?.transfer_main?.[0]?.warehouse_from_name}
                    selected={onWarehouseFromSelect}
                    {...register('warehouse_from_id', { required: 'WareHouse From is required!' })}
                  />
                </div>
                {errors.warehouse_from_id && (
                  <p className="text-red-500 text-xs mt-1">{errors.warehouse_from_id.message}</p>
                )}
              </div>

              <div className="relative z-0">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  To Warehouse <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <StockWareHouseSelect
                    list={getStockTransferData?.warehouse || []}
                    selected={onWarehouseToSelect}
                    defaultValue={editStockStransfer?.transfer_main?.[0]?.warehouse_to_name}
                    {...register('warehouse_to_id', { required: 'WareHouse to is required!' })}
                  />
                </div>
                {errors.warehouse_to_id && (
                  <p className="text-red-500 text-xs mt-1">{errors.warehouse_to_id.message}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Product Selection Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-6 z-0">
          <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 px-2 py-2">
            <h3 className="text-lg font-semibold text-white flex items-center gap-2">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
              Add Products
            </h3>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
              <div className="md:col-span-6 relative z-0">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Select Product
                </label>
                <div className="relative">
                  <StockProductSelect selected={onItemSelected} list={items || []} />
                </div>
              </div>

              <div className="md:col-span-3">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Quantity
                </label>
                <input
                  type="number"
                  min="1"
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>

              <div className="md:col-span-3">
                <button
                  onClick={addItem}
                  className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white rounded-lg px-6 py-2.5 text-sm font-semibold transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Item
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Items Table Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-gradient-to-r from-slate-700 to-slate-800 px-6 py-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-white flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Transfer Items
            </h3>
            <span className="bg-white text-slate-800 px-3 py-1 rounded-full text-sm font-semibold">
              {finalList.length} {finalList.length === 1 ? 'item' : 'items'}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 border-b-2 border-slate-200">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">ID</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Product Name</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">SKU</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Quantity</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {finalList.map((i, index) => (
                  <tr key={i.item_id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-4 text-sm text-slate-700 font-medium">{i.item_id}</td>
                    <td className="px-4 py-4">
                      <div className="flex flex-col">
                        <span className="text-sm font-medium text-slate-800">{i.item_name}</span>
                        <span className="text-xs text-emerald-600 font-semibold mt-1">
                          Available: {i.available_quantity}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm text-slate-600 text-center">{i.item_sku}</td>
                    <td className="px-4 py-4 text-center">
                      <input
                        type="number"
                        min="1"
                        className="w-24 border border-slate-300 rounded-lg px-3 py-1.5 text-sm text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={i.quantity}
                        onChange={(e) => updateQuantity(i.item_id, e.target.value)}
                      />
                    </td>
                    <td className="px-4 py-4 text-center">
                      <button
                        onClick={() => removeItem(i.item_id)}
                        className="text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {finalList.length === 0 && (
                  <tr>
                    <td colSpan="5" className="px-4 py-12 text-center">
                      <div className="flex flex-col items-center justify-center text-slate-400">
                        <svg className="w-16 h-16 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                        </svg>
                        <p className="text-lg font-medium">No products added yet</p>
                        <p className="text-sm mt-1">Select a product and click "Add Item" to begin</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-8 py-3 border-2 border-slate-300 text-slate-700 rounded-lg text-sm font-semibold hover:bg-slate-50 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-lg text-sm font-semibold transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Save Transfer
          </button>
        </div>
      </div>
    </div>
  );
}